import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Spinner } from '../../../../components'
import ExitIcon from '../../../../images/exit-modal_outlined.svg'
import { useAppDispatch } from '../../../../store'
import { unbindTxSlice } from '../../../../store/web3/unbind.side-effects'

interface Props {
  txHash?: string
  isMined: boolean
}

export const TxBroadcastedModal: React.FC<Props> = ({ txHash, isMined }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    ref.current?.scrollIntoView()
    ref.current?.focus()
  })

  return (
    <StyledTxBackground
      ref={ref}
      tabIndex={-1}
      onKeyDown={({ key }) => {
        if (key === 'Escape' && isMined) {
          dispatch(unbindTxSlice.actions.TX_CLEARED())
        }
      }}
    >
      <TxNft>
        <TxNftBackground>
          <TxNftBorder>
            <StyledH1>{t('Transaction Submitted')}</StyledH1>
            {txHash && (
              <LinkOut
                href={`https://explorer-mainnet.maticvigil.com/tx/${txHash}`}
                target="_blank"
                rel="noreferrer"
              >
                {t('View on Explorer')}
              </LinkOut>
            )}

            <SecondaryButton
              disabled={!isMined}
              onClick={() => {
                dispatch(unbindTxSlice.actions.TX_CLEARED())
              }}
            >
              {t('closeButton')}
            </SecondaryButton>
            <ExitButton
              disabled={!isMined}
              onClick={() => {
                dispatch(unbindTxSlice.actions.TX_CLEARED())
              }}
            >
              <img src={ExitIcon} alt="exit button" />
            </ExitButton>
            {isMined ? (
              <StyledTransactionStatus>
                {t('transactionMined')}
              </StyledTransactionStatus>
            ) : (
              <>
                <StyledTransactionStatus>
                  {t('awaitingTxConf')}
                </StyledTransactionStatus>
                <Spinner size={4} />
              </>
            )}
          </TxNftBorder>
        </TxNftBackground>
      </TxNft>
    </StyledTxBackground>
  )
}

const StyledTransactionStatus = styled.h2`
  color: white;
`

const ExitButton = styled.button`
  ${(props) => (!props.disabled ? '' : 'opacity: 50%;')}
  width: 2rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
`

const SecondaryButton = styled.button`
  ${(props) => (!props.disabled ? '' : 'opacity: 50%;')}
  color: white;
  border: 2px solid #00ffc2;
  padding: 1rem;
  font-family: 'Open Sans';
  width: 70%;
  border-radius: 18px;
  text-align: center;
  ${(props) =>
    props.disabled
      ? ''
      : `
  &:hover {
    background: #00ffc2;
    color: black;
  }`}
`

const LinkOut = styled.a`
  color: black;
  border: 2px solid #00ffc2;
  padding: 2rem;
  font-family: 'Open Sans';
  background: #00ffc2;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(6.5px);
  -webkit-backdrop-filter: blur(6.5px);
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  width: 70%;

  text-align: center;

  &:hover {
    background: #00ffc2;
    color: black;
  }
`

const StyledH1 = styled.h1`
  font-weight: 500;
`

const TxNftBackground = styled.div`
  background: black;
  @media (min-width: 200px) {
    padding: 1rem;
    width: 100%;
  }
  @media (min-width: 1200px) {
    padding: 2rem;
    width: min-content;
  }
`

const TxNftBorder = styled.div`
  border: 2px solid #00ffc2;
  position: relative;

  display: grid;
  grid-template-rows: min-content min-content min-content min-content min-content;
  row-gap: 2rem;
  justify-items: center;

  position: relative;

  @media (min-width: 200px) {
    padding: 1rem;
  }
  @media (min-width: 1200px) {
    width: 700px;
    padding: 4rem;
  }
`

const TxNft = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (min-width: 200px) {
  }
  @media (min-width: 1200px) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`

const StyledTxBackground = styled.section`
  z-index: 1001;
  background: rgba(0, 0, 0, 0.795);

  @media (min-width: 200px) {
    position: fixed;
    bottom: 0;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
  }

  @media (min-width: 750px) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
  }
`
